export default __webpack_public_path__ + "static/GeraldGneckow-a32c2133b200042577e1bd762c199e5c.jpg";